export default __webpack_public_path__ + "static/media/iconmonstr-arrow-66.5d230df2.svg";